var __TEMP__ = require('./isPlainObject.js');var isPlainObject = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = customOmitClone;
